// extracted by mini-css-extract-plugin
export var cardHeader = "_sn-0";
export var reorderHandle = "_sn-3";
export var titleArea = "_sn-1";
export var titleAreaWithHandle = "_sn-2";